import { FoljaLlojiTemes, FoljaZgjedhimi } from '@core/enums/folja.enum';

export class FoljaConstants {
  public static FoljaKoha = [
    { id: 10, short: 'tash.', long: 'E tashme' },
    { id: 11, short: 'kr.', long: 'E kryer' },
    { id: 12, short: 'pakr.', long: 'E pakryer' },
    { id: 13, short: 'm. kr.', long: 'Më se e kryer' },
    { id: 14, short: 'kr. thj.', long: 'E kryer e thjeshtë' },
    { id: 15, short: 'kr. tej.', long: 'E kryer e tejshkuar' },
    { id: 16, short: 'ardh.', long: 'E ardhme' },
    { id: 17, short: 'ardh. shk.', long: 'E ardhme e së shkuarës' },
    { id: 18, short: 'ardh. II', long: 'E ardhme II' },
    { id: 19, short: 'ardh. shk. II', long: 'E ardhme e së shkuarës II' },
    { id: 20, short: 'ardh. përp.', long: 'E ardhme e përparme' },
    { id: 21, short: 'ardh. përp. shk.', long: 'E ardhme e përparme e së shkuarës' },
    { id: 22, short: 'kr. mbp.', long: 'E kryer e mbipërbërë' },
    { id: 23, short: 'm. kr. mbp.', long: 'Më se e kryer e mbipërbërë' },
    { id: 24, short: 'tash. II', long: 'E tashme II' },
  ];

  public static FoljaKalimtaresia = [
    { id: 10, short: 'jokal.', long: 'Jokalimtare' },
    { id: 11, short: 'kal.', long: 'Kalimtare' },
  ];

  // public static FoljaPeremri = [
  //   { id: 10, short: 'u.', long: 'unë' },
  //   { id: 11, short: 't.', long: 'ti' },
  //   { id: 12, short: 'a.', long: 'ai/ajo' },
  //   { id: 13, short: 'n.', long: 'ne' },
  //   { id: 14, short: 'j.', long: 'ju' },
  //   { id: 15, short: 'at.', long: 'ata/ato' },
  // ];

  public static FoljaVeta = [
    { id: 10, short: "v.I", long: "E parë" },
    { id: 11, short: "v.II", long: "E dytë" },
    { id: 12, short: "v.III", long: "E tretë" },
    // { id: 13, short: "njëv.", long: "Njëvetore" },
  ];

  public static FoljaNumri = [
    { id: 10, short: "nj.", long: "Njëjës" },
    { id: 11, short: "sh.", long: "Shumës" },
  ];

  public static FoljaForma = [
    { id: 10, short: 'vep.', long: 'Veprore' },
    { id: 11, short: 'jovep.', long: 'Joveprore' },
  ];

  public static FoljaFormaSC = [
    { id: 10, short: 'vep.', long: 'Veprore' },
    // { id: 11, short: 'jovep.', long: 'Joveprore' },
  ];

  public static FoljaFormatFjales = [
    { id: 10, short: "f. ç'", long: "Forma me ç'" },
    { id: 11, short: "f. s'", long: "Forma me s'" },
  ];

  public static FoljaFormaFjalesMeC = [
    { id: 10, short: "f. ç'", long: "Forma me ç'" },
    // { id: 11, short: "f. s'", long: "Forma me s'" },
  ];

  public static FoljaFormaFjalesMeS = [
    // { id: 10, short: "f. ç'", long: "Forma me ç'" },
    { id: 11, short: "f. s'", long: "Forma me s'" },
  ];

  public static FoljaFormaPashtjelluar = [
    { id: 10, short: 'pjes.', long: 'Pjesore' },
    { id: 11, short: 'përcj.', long: 'Përcjellore' },
    { id: 12, short: 'pask. I', long: 'Paskajore I' },
    { id: 13, short: 'pask. II', long: 'Paskajore II' },
    { id: 14, short: 'pask. III', long: 'Paskajore III' },
    { id: 15, short: 'pask. geg.', long: 'Paskajore gege*' },
    { id: 16, short: 'moh.', long: 'Mohore' },
  ];

  public static GetFormulas(baza: string, zgjedhimi: FoljaZgjedhimi, llojiTemes: FoljaLlojiTemes, manualInput?: string) {
    switch (zgjedhimi) {
      case FoljaZgjedhimi.I: {
        switch (llojiTemes) {
          // Punoj
          case FoljaLlojiTemes.MeTemeO: {
            let F1 = baza.replaceLastOccurrence('j');
            let F5 = F1.replaceLastOccurrence('o', 'ua');
            let F6 = F5 + 'r';

            return { F1, F5, F6 };
          }
          // Rrëfej
          case FoljaLlojiTemes.MeTemeE: {
            let F1 = baza.replaceLastOccurrence('j');
            let F5 = F1.replaceLastOccurrence('e', 'ye');
            let F6 = F5 + 'r';

            return { F1, F5, F6 };
          }
          // Shkruaj
          case FoljaLlojiTemes.MeTemeUA: {
            let F1 = baza.replaceLastOccurrence('j');
            let F3b = F1.replaceLastOccurrence('a');
            let F4 = F1.replaceLastOccurrence('ua', 'o');
            let F6 = F1 + 'r';

            return { F1, F3b, F4, F6 };
          }
          // Lyej
          case FoljaLlojiTemes.MeTemeYE: {
            let F1 = baza.replaceLastOccurrence('j');
            let F3b = F1.replaceLastOccurrence('e');
            let F4 = F1.replaceLastOccurrence('ye', 'e');
            let F6 = F1 + 'r';

            return { F1, F3b, F4, F6 };
          }
          // Blej
          case FoljaLlojiTemes.KanTeNjejtenTeme: {
            let F1 = baza.replaceLastOccurrence('j');
            let F3 = F1.replaceLastOccurrence('e', 'i');
            let F6 = F1 + 'rë';

            return { F1, F3, F6 };
          }
          // Arrij
          case FoljaLlojiTemes.ZgjerimTemeMT: {
            let F1 = baza.replaceLastOccurrence('j');
            let F4 = F1 + 't';
            let F6 = F4 + 'ur';

            return { F1, F4, F6 };
          }
          // Mbaj
          case FoljaLlojiTemes.ZgjerimTemeMJT: {
            let F1 = baza.replaceLastOccurrence('j');
            let F4 = F1 + 'jt';
            let F6 = F4 + 'ur';

            return { F1, F4, F6 };
          }
          // Ruaj
          case FoljaLlojiTemes.MeTemeUAdheZgjerimTemeMeJT: {
            let F1 = baza.replaceLastOccurrence('j');
            let F3b = F1.replaceLastOccurrence('a');
            let F4 = F1 + 'jt';
            let F6 = F4 + 'ur';

            return { F1, F3b, F4, F6 };
          }
          // Bëj
          case FoljaLlojiTemes.ZgjerimTemeMR: {
            let F1 = baza.replaceLastOccurrence('j');
            let F4 = F1 + 'r';
            let F6 = F4 + 'ë';

            return { F1, F4, F6 };
          }
        }

        break;
      }
      case FoljaZgjedhimi.II: {
        switch (llojiTemes) {
          //Hap
          case FoljaLlojiTemes.KanTeNjejtenTeme: {
            let F1 = baza;
            let F6 = F1 + 'ur';

            return { F1, F6 };
          }
          //Mas/Mat
          case FoljaLlojiTemes.FoljeMeDysoreNeDisaFormaTS: {
            let F1a = baza.replaceLast('s', 't');
            let F1b = baza.replaceLast('t', 's');
            let F6 = F1a + 'ur';

            return { F1a, F1b, F6 };
          }
          //Mas
          case FoljaLlojiTemes.MasFoljeDysore1MeS: {
            let F1 = baza;
            let F2 = F1.replaceLast('s', 't');
            let F6 = F2 + 'ur';

            return { F1, F2, F6 };
          }
          //Mat
          case FoljaLlojiTemes.MatFoljeDysore2MeT: {
            let F1 = baza;
            let F2 = F1.replaceLast('t', 's');
            let F6 = F1 + 'ur';

            return { F1, F2, F6 };
          }
          //Dredh
          case FoljaLlojiTemes.MeTemeE: {
            let F1 = baza;
            let F3 = baza.replaceLastOccurrence('e', 'i');
            let F4 = baza.replaceLastOccurrence('e', 'o');
            let F6 = baza + 'ur';

            return { F1, F3, F4, F6 };
          }
          // Nxjerr
          case FoljaLlojiTemes.MeTemeJE1: {
            let F1 = baza;
            let F3 = baza.replaceLastOccurrence('je', 'i');
            let F4 = baza.replaceLastOccurrence('je', 'o').replaceLastOccurrence('rr', 'r');
            let F6 = baza + 'ë';

            return { F1, F3, F4, F6 };
          }
          // Pjek
          case FoljaLlojiTemes.MeTemeJE2: {
            let F1 = baza;
            let F3 = baza.replaceLastOccurrence('je', 'i').replaceLastOccurrence('k', 'q');
            let F4 = F3.replaceLastOccurrence('i', 'o');
            let F6 = baza + 'ur';

            return { F1, F3, F4, F6 };
          }
          // Djeg
          case FoljaLlojiTemes.MeTemeJE3: {
            let F1 = baza;
            let F3 = F1.replaceLastOccurrence('je', 'i').replaceLastOccurrence('g', 'gj');
            let F4 = F3.replaceLastOccurrence('i', 'o');
            let F6 = F1 + 'ur';

            return { F1, F3, F4, F6 };
          }
          // Dal
          case FoljaLlojiTemes.MeTemeA1: {
            let F1 = baza;
            let F2 = F1.replaceLastOccurrence('a', 'e');
            let F3 = F1.replaceLastOccurrence('a', 'i');
            let F4 = F1.replaceLastOccurrence('a', 'o');
            let F6 = F1 + 'ë';

            return { F1, F2, F3, F4, F6 };
          }
          // Marr
          case FoljaLlojiTemes.MeTemeA2: {
            let F1 = baza;
            let F2 = baza.replaceLastOccurrence('a', 'e');
            let F3 = F2;
            let F4 = baza.replaceLastOccurrence('a', 'o').replaceLastOccurrence('rr', 'r');
            let F6 = baza + 'ë';

            return { F1, F2, F3, F4, F6 };
          }
          // Përkas
          case FoljaLlojiTemes.FoljetMeTemeTeZgjeruarTeTipitPerkas: {
            let F1 = baza;
            let F2 = F1.replaceLastOccurrence('a', 'e').replaceLastOccurrence('s', 't');
            let F3a = F2.replaceLastOccurrence('e', 'i');
            let F3b = F1.replaceLastOccurrence('a', 'i');
            let F6 = F3a + 'ur';

            return { F1, F2, F3a, F3b, F6 };
          }
          // Shkas
          case FoljaLlojiTemes.FoljetShkasVrasNgasDheGergas: {
            let F1 = baza;
            let F2 = baza.replaceLastOccurrence('a', 'e').replaceLastOccurrence('s', 't');
            let F3a = F2.replaceLastOccurrence('e', 'i');
            let F3b = baza.replaceLastOccurrence('a', 'i');
            let F4 = baza.replaceLastOccurrence('s');
            let F6 = F4 + 'rë';

            return { F1, F2, F3a, F3b, F4, F6 };
          }
        }

        break;
      }
      case FoljaZgjedhimi.III: {
        switch (llojiTemes) {
          // Vë
          case FoljaLlojiTemes.NeTeKryerenEThjeshteNjejesMeTemeTeZgjeruarMeR: {
            let F1 = baza;
            let F3 = baza.replaceLastOccurrence('ë', 'i');
            let F4 = baza.replaceLastOccurrence('ë', 'u') + 'r';
            let F5 = baza.replaceLastOccurrence('ë', 'u');
            let F6a = baza + 'në';
            let F6b = baza + 'n';

            return { F1, F3, F4, F5, F6a, F6b };
          }
          // Di
          case FoljaLlojiTemes.NeTeKryerenEThjeshteDheNePjesoreEZgjerojneTemenMePrapashtesenT: {
            let F1 = baza;
            let F4 = baza + 't';
            let F6 = F4 + 'ur';

            return { F1, F4, F6 };
          }
          // Pi
          case FoljaLlojiTemes.FoljaPi: {
            let F1 = baza;
            let F3 = baza;
            let F6 = baza + 'rë';

            return { F1, F3, F6 };
          }
          // Shtie
          case FoljaLlojiTemes.FoljaShtie: {
            let F1 = baza;
            let F3 = baza.replaceLastOccurrence('e');
            let F6a = baza.replaceLastOccurrence('ie', 'ë') + 'në';
            let F6b = baza.replaceLastOccurrence('ie', 'ë') + 'n';
            let F7 = F3;

            return { F1, F3, F6a, F6b, F7 };
          }
        }

        break;
      }
      case FoljaZgjedhimi.PaRregullt: {
        switch (llojiTemes) {
          case FoljaLlojiTemes.Supletive: {
            break;
          }
          case FoljaLlojiTemes.Josupletive: {
            break;
          }
        }

        break;
      }
    }
    throw new Error('Formula not implemented!');
  }
}
